// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WnXf0","content":"styles_content__1Aks-","tableWrap":"styles_tableWrap__2X-jF"};